export enum Roles {
  ADMIN = 'Admin',
  CUSTOMER = 'Customer',
  BUSINESS_CUSTOMER = 'BusinessCustomer',
  OPERATOR = 'Operator',
  SUPER_ADMIN = 'SuperAdmin',
}
